import React, { useEffect, useState } from "react";
import styles from "./experience.module.scss"
import cx from "classnames";

const MetroGifUrl = `/images/Metro.gif`;
const BentoGifUrl = `/images/Bento.gif`;
const CarouselGifUrl = `/images/Carousel.gif`;

interface ViewerCardProps {
  title: string;
  gifUrl: string;
  description: string;
  isSelected: boolean;
  onSelect: () => void;
}

interface ExperienceProps {
  onChange?: (newType: string) => void;
  selectedViewerType?: string;
}

const viewerContent = [
  { title: "Metro", gifUrl: MetroGifUrl, description: "Clean grid layout with content previews. Best for visual content and product catalogs.", type: "MASONRY" },
  { title: "Bento", gifUrl: BentoGifUrl, description: "Mixed-size tiles for content hierarchy. Best for: Highlighting key pieces, varied content types.", type: "BENTO_GRID" },
  { title: "Carousel", gifUrl: CarouselGifUrl, description: "Horizontal scrolling showcase. Best for: Sequential content, presentations.", type: "CAROUSEL" },
];

const Experience: React.FC<ExperienceProps> = ({ onChange, selectedViewerType }) => {

  const initialSelectedItem =
    viewerContent.find(item => item.type === selectedViewerType) || viewerContent[0];

  const [selected, setSelected] = useState(initialSelectedItem);

  const handleSelect = (item: typeof viewerContent[0]) => {
    setSelected(item);
    onChange?.(item.type);
  };

  useEffect(() => {
    const newViewerType =
      viewerContent.find(item => item.type === selectedViewerType) || viewerContent[0];
    setSelected(newViewerType);
  }, [selectedViewerType]);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.heading}>Default Experience</div>
        <div className={styles.description}>
          Choose how recipients browse your content.
        </div>

        <div className={styles.cardsWrapper}>
          {viewerContent.map((item) => {
            const isSelected = selected.title === item.title;

            return (
              <div
                key={item.title}
                className={cx(styles.card, {
                  [styles.active]: isSelected,
                })}
                onClick={() => handleSelect(item)}
              >
                <ViewerCard
                  title={item.title}
                  gifUrl={item.gifUrl}
                  description={item.description}
                  isSelected={isSelected}
                  isActive={isSelected}
                  onSelect={() => handleSelect(item)}
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Experience;

const ViewerCard: React.FC<ViewerCardProps & { isActive: boolean }> = ({
  title,
  gifUrl,
  description,
  isSelected,
  isActive,
  onSelect,
}) => {
  const bottomOffset = title === "Bento" || title === "Carousel";

  return (
    <div className={styles.experienceWrapper}>
      <div className={cx(styles.title, { [styles.offset]: bottomOffset })}>{title}</div>
      <div className={cx(styles.experienceCard, { [styles.hover]: isActive }, { [styles.active]: isSelected })}>
        <div className={styles.imageContainer}>
          <img src={gifUrl} alt={title} className={styles.gif} />
        </div>
        <div className={styles.caption}>
          <label className={styles.radioWrapper} onClick={onSelect}>
            <i
              className={cx(styles.checkbox, {
                "paperflite-radio-button-selected": isSelected,
                "paperflite-radio-button-unselected": !isSelected,
                [styles.primary]: isSelected,
              })}
              aria-hidden="true"
            />
            <span
              className={cx(styles.radioLabel, {
                [styles.primary]: isSelected,
              })}
            >
              {title}
            </span>
          </label>
          <div className={styles.description}>{description}</div>
        </div>
      </div>
    </div>
  );
};